import 'styled-components';
/*
 * Styles are derived from Prism and Bootstrap
 * https://ghe.coxautoinc.com/Prism/prism/tree/master/src/styles/themes/prism/vars
 * https://github.com/twbs/bootstrap/blob/5f2480a90ab911babc53039835fe78c6fc12646d/scss/_variables.scss
 */

type AppTheme = typeof $APP_THEME;

declare module 'styled-components' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/consistent-type-definitions
  export interface DefaultTheme extends AppTheme {}
}

export const $APP_THEME = {
  typography: {
    family: {
      primary: "'Roboto', sans-serif",
      condensed: "'Roboto Condensed', sans-serif",
      mono: "'Roboto Mono', monospace"
    },
    weight: {
      lighter: 'lighter',
      light: 300,
      normal: 400,
      bold: 700,
      bolder: 'bolder'
    },
    size: {
      xs: '1.2rem',
      sm: '1.4rem',
      md: '1.6rem',
      lg: '2.6rem'
    }
  },
  radius: {
    sm: '0.2rem',
    md: '0.4rem',
    lg: '0.8rem'
  },
  spacing: {
    spacer1: '0.4rem',
    spacer2: '0.8rem',
    spacer3: '1.6rem',
    spacer4: '2.4rem',
    spacer5: '3.2rem',
    spacer6: '4rem'
  },
  breakpoints: {
    xs: 0,
    sm: 480,
    md: 680,
    lg: 960,
    xl: 1168,
    xxl: 1360,
    xxxl: 1456
  },
  breakpointsMax: {
    xs: 479,
    sm: 679,
    md: 959,
    lg: 1167,
    xl: 1359,
    xxl: 1455,
    xxxl: 99999
  },
  /* Color Reference (Default Theme): https://prism.coxautoinc.com/docs/themes/manheim-default/
   * Alternatively, see `:root` selector in PRISM's styles package (@prism/styles/prism.comps.css) for color values.
   */
  colors: {
    blue: 'var(--blue)',
    indigo: 'var(--indigo)',
    purple: 'var(--purple)',
    pink: 'var(--pink)',
    red: 'var(--red)',
    orange: 'var(--orange)',
    yellow: 'var(--yellow)',
    green: 'var(--green)',
    teal: 'var(--teal)',
    cyan: 'var(--cyan)',
    white: 'var(--white)',
    gray: 'var(--gray)',
    grayDark: 'var(--gray-dark)',
    scarlet: 'var(--scarlet)',
    scarletDark: 'var(--scarlet-dark)',
    scarletLight: 'var(--scarlet-light)',
    gold: 'var(--gold)',
    goldDark: 'var(--gold-dark)',
    goldLight: 'var(--gold-light)',
    saffron: 'var(--saffron)',
    saffronDark: 'var(--saffron-dark)',
    meadow: 'var(--meadow)',
    jungle: 'var(--jungle)',
    meadowLight: 'var(--meadow-light)',
    ocean: 'var(--ocean)',
    navy: 'var(--navy)',
    navyDark: 'var(--navy-dark)',
    blueDark: 'var(--blue-dark)',
    cerulean: 'var(--cerulean)',
    ceruleanDark: 'var(--cerulean-dark)',
    ceruleanLight: 'var(--cerulean-light)',
    plum: 'var(--plum)',
    mist: 'var(--mist)',
    ash: 'var(--ash)',
    cloudy: 'var(--cloudy)',
    smoke: 'var(--smoke)',
    pewter: 'var(--pewter)',
    slate: 'var(--slate)',
    graphite: 'var(--graphite)',
    charcoal: 'var(--charcoal)',
    carbon: 'var(--carbon)',
    black: 'var(--black)',
    transparent: 'var(--transparent)',
    primary: 'var(--transparent)',
    secondary: 'var(--secondary)',
    success: 'var(--success)',
    info: 'var(--info)',
    warning: 'var(--warning)',
    danger: 'var(--danger)',
    light: 'var(--light)',
    dark: 'var(--dark)',
    secondaryDark: 'var(--secondary-dark)'
  }
};
